import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import icn1 from '../../assets/icons/user-star.png'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Physical-Design-Brochure.pdf";
    window.open(pdfUrl);
};

const Physicalpt = () => {
    const faqSchema={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the focus of the Physical Design Part-Time course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our Physical Design Part-Time course is all about hands-on experience in VLSI physical design. You will dive into everything from floor planning to routing and physical verification using the latest industry tools. Perfect for professionals who want to level up their skills!"
      }
    },
    {
      "@type": "Question",
      "name": "Who should consider taking this VLSI physical design part-time course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "This course is the best option for working professionals who belong to electronics and are looking to deepen their knowledge in VLSI physical design. If you are an engineer or want to master physical design, this is for you!"
      }
    },
    {
      "@type": "Question",
      "name": "What can you expect to learn in the Physical Design Education provided?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In our Physical Design Education, you’ll gain a thorough understanding of physical design flow. Expect to learn about Linux environments, power planning, timing analysis, and much more. By the end, you’ll be well-versed in the entire physical design process!"
      }
    },
    {
      "@type": "Question",
      "name": "How does the Physical Design Part-Time course fit into my busy schedule?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The course is designed to fit around your existing job. You’ll get flexible access to lab support and materials, making it easier to balance learning with your work commitments."
      }
    },
    {
      "@type": "Question",
      "name": "Who can join the course in the Physical Design Classes?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You have to come from an electrical or electronics background, such as a B.E, B.Tech in ECE or EEE, or an M.E, M.Tech, or M.S in VLSI and Embedded Systems. This background ensures that you are able to learn the advanced topics."
      }
    },
    {
      "@type": "Question",
      "name": "Brief description of Physical design course details?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We provide the best practical knowledge about the tools and techniques and concentrate on placing you in the best company. It covers everything from basics like Unix/Linux commands and CMOS operations to advanced topics."
      }
    },
    {
      "@type": "Question",
      "name": "How experienced are the instructors for the Physical Design Course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our instructors, like Mr. Chaitanya, bring over 12 years of hands-on experience in RTL to GDSII implementation. They have worked on complex blocks like PCIe and DDR_PHY so you will be learning from true experts in the field."
      }
    },
    {
      "@type": "Question",
      "name": "What practical skills will you learn from the Physical Design for Professionals course?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You will learn and get real practice with industry-standard EDA tools. You’ll learn how to manage floor planning, power planning, and routing—all crucial skills for a career in physical design."
      }
    }
  ]
};

const courseSchema={
  "@context": "https://schema.org",
  "@type": "Course",
  "@id": "https://takshila-vlsi.com/product/physical-design-part-time/#course",
  "name": "Physical Design Part Time Training Course",
  "description": "Part-time Physical Design training covering the complete physical design and physical verification flow, including Linux, floor planning, power planning, timing analysis, clock tree synthesis, routing, physical verification and sign-off checks with hands-on EDA tool practice.",
  "url": "https://takshila-vlsi.com/product/physical-design-part-time/",
  "provider": {
    "@type": "Organization",
    "name": "Takshila VLSI",
    "url": "https://takshila-vlsi.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg"
    },
    "email": "info@takshila-vlsi.com",
    "telephone": "+91-9742972744"
  },
  "coursePrerequisites": "B.E/B.Tech in ECE/EEE, or M.E/M.Tech/M.S in VLSI, Embedded Systems or Digital Electronics.",
  "timeRequired": "P5M",
  "hasCourseInstance": {
    "@type": "CourseInstance",
    "courseMode": "Part-time",
    "location": [
      {
        "@type": "Place",
        "name": "Bengaluru"
      },
      {
        "@type": "Place",
        "name": "Hyderabad"
      }
    ],
    "courseWorkload": "P5M"
  },
  "instructor": {
    "@type": "Person",
    "name": "Mr. Chaitanya",
    "jobTitle": "Physical Design Expert"
  },
  "about": [
    "Physical Design",
    "Physical Verification",
    "RTL to GDSII",
    "ASIC Design",
    "Synthesis",
    "Static Timing Analysis",
    "Clock Tree Synthesis",
    "Floor Planning",
    "Power Planning",
    "Routing",
    "DFT",
    "Sign-off Checks",
    "Linux",
    "EDA Tools"
  ],
  "teaches": [
    "Introduction to Electronics, MOSFET & CMOS Theory",
    "Digital Electronics",
    "Basics of UNIX/LINUX",
    "Introduction to ASIC Design",
    "Introduction to Verilog",
    "Introduction to DFT",
    "Synthesis",
    "Static Timing Analysis Part 1",
    "Static Timing Analysis Part 2",
    "Physical Design",
    "Physical Design Verification",
    "Industry Standard Project Execution",
    "Mock Interviews & Personality Development"
  ]
};

  return (
    <div>
        <Helmet>
            <title>Physical Design Part-Time Course & Fee Details | Takshila VLSI</title>
            <meta name="description" content="Enroll in a Physical Design Part-Time course to master floorplanning, placement, routing, and STA while continuing your full-time job with Takshila VLSI." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/product/physical-design-part-time/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Physical Design Part-Time Course & Fee Details | Takshila VLSI" />
            <meta property="og:description" content="Enroll in a Physical Design Part-Time course to master floorplanning, placement, routing, and STA while continuing your full-time job with Takshila VLSI." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/product/physical-design-part-time/" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="article:modified_time" content="2024-08-10T08:09:19+00:00" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2018/12/Home-Page-Banner-1-1024x576.png" />
            <meta property="og:image:width" content="1024" />
            <meta property="og:image:height" content="576" />
            <meta property="og:image:type" content="image/png" />
            <meta name="twitter:card" content="summary_large_image" />

            <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
                </script>
                <script type="application/ld+json">
                {JSON.stringify(courseSchema)}
                </script>
        </Helmet>
        <Header/>
        <main>
            <section class="section-banner pg-banner ws-section pt-5 bg-14">
            <div class="container text-center">
                        <div class="row justify-content-around p-lg-5 pb-0">
                            <div class="col-md-9">
                                <div class="pg-title-sec">
                                    <h1 className='pg-title pb-3'>Physical
                                    <span className='bg-txt'>Design</span> Part Time
                                    </h1>
                                    <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                                </div>
                            </div>
                            <div class="col-md-12 align-self-center mb-3">
                                    <a href="/register-now">
                                        <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                    </a>
                            </div>
                        </div>
                        <div class="row justify-content-center img-radius g-3">
                            <div class="col-md-2 align-self-end d-none d-sm-block">
                            <img src={img1} alt=''/>
                            </div>
                            <div class="col-md-2 align-self-end">
                            <div className='course-bnr-bx bg-8 radius-1'>
                                    <h4 className='course-bnr-title'>100%</h4>
                                    <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                                </div>
                            </div>
                            <div class="col-md-3 align-self-end">
                            <img src={img2} alt=''/>
                            </div>
                            <div class="col-md-2 align-self-end">
                            <div className='course-bnr-bx bg-7 radius-1'>
                                    <h4 className='course-bnr-title'>100%</h4>
                                    <p className='course-bnr-desc'>Learners became better at their job</p>
                                </div>
                            
                            </div>
                            <div class="col-md-2 align-self-end d-none d-sm-block">
                            <img src={img3} alt=''/>
                            </div>
                        </div>
            </div>
        </section>
        <section className='course-desc p-lg-5 bg-14'>
                <div class="container text-center">
                        <div class="row justify-content-around text-center">
                            <div class="col-md p-5">
                                    <h2 className='ws-section_heading pd-03'><span className='font-thin'>VLSI Chip Design Training & Physical Design </span>Courses in Bangalore/ Hyderabad</h2>
                            </div>
                        </div>
                        <div class="row justify-content-around">
                            <div class="col-md">
                                    <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                    <div className='text-left text-xl'>
                                    <p>Physical Design part time course mainly focused on giving complete hands on experience to physical design and physical verification flow with latest tools and full lab practice. By end of the course your will learn to work in Linux environment, understand complete physical design flow from portioning, floor planning, power planning, timing analysis, clock tree synthesis, routing of a functional unit blocks to physical verification and sign-off checks.</p>
                                    </div>
                            </div>
                        </div>
                </div>
        </section>
        <section className='highlight-section p-lg-5 p-2 bg-14'>
            <div class="container bg-9 p-lg-5 p-3 radius-1">
                <div className='txt-3 mb-3'>Industry Standard VLSI and DFT Training</div>
                <div className='mb-5'>
                <div className='txt-2 mb-2'>Eligibility</div>
                <div class="row">
                    <div className='col-lg'>
                    <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>B.E/B.Tech in ECE/EEE.</div>
                    </div>
                    </div>
                    <div className='col-lg'>
                    <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>M.E/M.Tech/M.S in VLSI/Embedded Systems/Digital Electronics.</div>
                    </div>
                    </div>
                </div>
                </div>
                <div className='mb-5'>
                <div className='txt-2 mb-2'>Course Duration</div>
                <div class="row">
                    <div className='col-lg'>
                    <div className='icon-left-bx d-flex'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>5 Months</div>
                    </div>
                    </div>
                
                </div>
                </div>
                <div>
                <div className='txt-2 mb-2'>Course Highlights</div>
                <div class="row">
                    <div className='col-lg'>
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Hands-on exposure to physical design flow with industry standard EDA tools.</div>
                    </div>
                
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Deep understanding of various methodologies and technologies used.</div>
                    </div>
                    
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>24X7 Lab Support with Lab practice handouts and course material delivery.</div>
                    </div>
                    
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Industry standard project execution from RTL to gdsii training, Lab practice and theory sessions under the guidance of industry expert with 12+ years of experience.</div>
                    </div>
                    
                    <div className='icon-left-bx d-flex mb-2'>
                        <div className='icn-img'> <img src={icncheck} alt=''/></div>
                        <div className='icn-heading'>Soft skills development, complete suite of job oriented physical design training with 100% placement assistance.</div>
                    </div>
                    </div>
                </div>
                </div>
                    
            </div>
        </section>

        <section className='author-section p-lg-5 p-2 bg-14'>
        <div className='container'>
        <div class="row">
                <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 mr--10 mt-5 p-3 mb-3">
                <h2 class="ws-section_heading mb-3">About Instructors</h2>
                <a href='/teachers/chaitanya/'><h4>Mr. Chaitanya</h4></a>
                <h6 className='pb-3'>(Physical Design Expert)</h6>
                <p>Mr. Chaitanya comes with 12+ years of experience in RTL to GDSII implementation of IP's, Sub-System's and SoC's. Hands on experience in RTL2GDSII flow of multiple complex blocks like PCIe, SATA, DDR_PHY, HBM_PHY, processor's and also have experience on DFT design flows and Design Constraints development.</p>
                <div class="wpb_wrapper">
                <div class="row g-3">
                        <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                        <p><strong>Expertise Areas:</strong></p>
                <p>Low power implementation and strategies<br/>
                Mode specific Design constraints development<br/>
                Clock Tree Building at Block and Full-Chip<br/>
                Full-Chip Timing Analysis and Timing Closure<br/>
                Logical Equivalence Check and Low power checks<br/>
                SI/Cross_talk analysis</p>
                        </div>
                        <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                            <p><strong>Technology Process Worked On:</strong><br/> 
                            <strong>Finfet Technologies:</strong> 7nm and 16nm<br/>
                    <strong>Nominal Technologies:</strong> 28nm, 40nm, 65nm, 90nm &amp; 130nm.</p>
                    <p><strong>IC Foundries Worked with:</strong> TSMC, UMC, GF</p>
                    
                        </div>
                        <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                            
                    <p><strong>EDA tools known for Physical design :</strong></p> <p>Genus/RTL_Compiler/DC, Conformal, Encounter/Innovus, QRC Extraction, PrimeTime/Tempus<br/>
                    Physical verification tools known: Redhawk/Voltus, Calibre DRC, Calibre LVS</p>
                        </div>
                    </div>
                        </div>
                </div>
                <div class="col-lg img-radius">
                <img src={instimg} alt=''/>
                </div>
            </div>
            </div>
        </section>

        <section className='curriculum-section pt-5'>
            <div className='container'>
                <div class="row justify-content-center mb-5">
                <div class="col-lg-8 text-center">
                <h3 class="ws-section_heading pb-03 txt-3">Physical design training institute 
                with placement</h3>
                </div>
                </div>
                <div class="row mb-5">
                    <div class="col-lg-8">
                    <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
                    </div>
                    <div class="col-lg-4 align-self-center">
                   <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                    
                    </div>
                </div>
                 <div className='row'>
                <div className='col-lg'>
                <div className='curriculum-accord accordion'>
                        <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Module 1: Introduction to Electronics,
MOSFET & CMOS Theory</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Introduction to Electronics and MOSFET Theory</div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Introduction to CMOS Process and Circuits</div>
                            </div>
                            
                        </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Module 2: Digital Electronics</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Binary system and Boolean algebra</div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Combinational Circuits</div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Sequential circuits - Counters, state machines, shift registers</div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Module 3: Basics of UNIX/LINUX</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Introduction to Unix/Linux Commands  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>VI Editor Commands  
                            </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header>Module 4: Introduction to ASIC Design</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>ASIC Flow 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>All Stages Discussion 
                            </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header>Module 5: Introduction to Verilog</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Basic Concepts 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Gate - Level Modeling  
                                </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Dataflow Modeling 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Behavioural Modeling 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Tasks and Functions 
                            </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="5">
                            <Accordion.Header>Module 6: Introduction to DFT</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>DFT Basics  
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Fault Modeling
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Logic and Fault Simulation
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>SCAN Design
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Introduction to BIST
                            </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="6">
                            <Accordion.Header>Module 7: Synthesis</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Inputs and Outputs understanding 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Constraints development and understanding 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Optimization techniques (uniqify, preserve, flatten) 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Wireload model, PLE, Physical, Spatial 
                            </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="7">
                            <Accordion.Header>Module 8: Static Timing Analysis Part – 1</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Basic understanding of transition/slew, capacitance, leakage power,
internal power, On-Chip-Variation (derate, AOCV, LVF) 
                            </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Library file difference NLDM, CCS, ECSM, LVF  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Timing concepts understanding such as setup, hold, recovery, removal,
pulse width, clock gating check  </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="8">
                            <Accordion.Header>Module 9: Static Timing Analysis Part – 2</Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>PLL jitter understanding and uncertainty calculations  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>IO budgeting</div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Different Timing Modes understanding  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Introduction to ECO  </div>
                            </div>
                            
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="9">
                            <Accordion.Header>Module 10: Physical Design
                            </Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Input files, Sanity Checks and IO placement  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Floorplanning and Power planning concepts  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Placement strategies like region, fence, blockages, pading, bump, dont
touch, filler gap, DRV optimization, Buffer tree synthesis  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Clock tree synthesis and clock latency calculations </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Routing design and optimization, antenna Effect and Latch up issue </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>ECO Timing closure and implementation cycle </div>
                            </div>
                        
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="10">
                            <Accordion.Header>Module 11: Physical Design Verification
                            </Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Design Rule Checks understanding and importance  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Layout Versus Schematic and difference with respect to LEC </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Electrical Rule Checks  </div>
                            </div>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>IR Drop analysis - Static and Dynamic </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="11">
                            <Accordion.Header>Module 12: Industry standard Project Execution
                            </Accordion.Header>
                            <Accordion.Body>
                            <div className='icon-left-bx d-flex mb-2'>
                                <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                <div className='icn-heading'>Industry Standard Physical Design Live Project </div>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="12">
                            <Accordion.Header>Module 12: Mock Interviews & Personality
Development
                            </Accordion.Header>
                        </Accordion.Item>
                        </Accordion>
                        </div>
                </div>
            </div>

            </div>
                    </section>

                    <section className='video-section p-lg-5 pt-4'>
            <div class="container text-center">
                <div className='row'>
                    <div className='col-lg text-center'>
                    <h2 class="ws-section_heading">Physical Design Demo Videos</h2>
                </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-4">
                    <iframe
                        width="100%"
                        height="250"
                        src={`https://www.youtube.com/embed/vhMYlUAzIM4`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube"
                        poster="hqdefault"
                    />
                </div>
                <div class="col-lg-4">
                <iframe
                    width="100%"
                    height="250"
                    src={`https://www.youtube.com/embed/XXnsREczc60`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                    poster="hqdefault"
                />
                </div>
                </div>
            </div>
        </section>


                    <Companysec/>
                    <section className='ws-section pb-5 bg-white'>
                        <div class="container text-center">
                        <div class="row justify-content-around">
                                        <div class="col-lg-6">
                                            <div className='trainer-box'>
                                            
                                                <div className='trainer-img img-radius mb-3'>
                                                <img src={tr1} alt=''/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-left">
                                            <h2 className='mb-4'>5 Real Reasons Why Progressively More People Are Rushing Our Physical Design Training</h2>
                                            <div class="wpb_wrapper">
                                                    <p>In VLSI, physical design is conversion of netlist to layout in a given chip by meeting aspects of area, power, performance (STA), thus honoring time to market. Placement of cells, routing of metals that connect logic gates, floorplan, clock building, and meeting the needed timing frequency is the main goal of physical design.</p>
                                        <p>It’s among the chip design industry’s most critical stages. It’s the stage in which most schedule delays are recovered to meet the TTM. Pro-activeness, in-depth analysis and understating, flawless design, and proven experience, are the key requirements for getting a chip right on time and on the first pass. These key requirements are precisely what we teach with our famous physical design training. There are several reasons why progressively more individuals keep rushing to join the training and they include;</p>

                                                </div>
                                            <div className='course-accord dark-bg'>
                                        <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>1. We Are a Physical Design Training Institute With . 100% Placement</Accordion.Header>
                                            <Accordion.Body>
                                            As the foremost of all physical design institutes in Bangalore, our students rest assured of 100% placement in the best product or service based companies after completing their physical design course with us. Also, we have the best of all physical design training institutes in Hyderabad which does the same for our teeming students. Our 100% placement feature has seen some of our past students building the most amazing careers in the VLSI industry. That’s why we are ahead of all physical design training institutes in Hyderabad and around the world.</Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>2. Course Content</Accordion.Header>
                                            <Accordion.Body>
                                            Our physical Design Training focuses providing a full hands-on experience of physical design training and physical verification training flow with complete laboratory practice using the most trending tools presently available in the industry. This is quite unlike other physical design training institutes in Bangalore or Hyderabad. Certainly, we’ve gone ahead and none can catch up with us.<br/>

            <br/>After you complete this course, you will the flow of physical design from partitioning, power planning, clock tree synthesis, physical verification, floor planning, timing analysis, routing of functional unit blocks, and sign-off checks. This also makes you a complete master of Physical Design. So, which other physical design training institutes in Hyderabad offer content that goes this deep? We give our students RTL to GDSii training so they can work between varying necessary file formats.
            
            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>3. The Best Physical Design Training Institute</Accordion.Header>
                                            <Accordion.Body>
                                            Yes, we’re certainly the best physical design training institute around and yet we’re a low cost physical design training institute. If you compare the little we charge to the quality of our instructors, lessons, and materials, you will understand that we certainly offer lots more value for the money our students pay. This alone has helped ensure that we are seen by all industry experts as one of the best physical design training institutes in India and around the whole world.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>4. We are among the India’s Top 10 Physical Design Institutes</Accordion.Header>
                                            <Accordion.Body>
                                            Apart from being among the top 10 physical design institutes in India, we’re also the no 1 physical design training institute in Bangalore. This shows the whole world is beginning to recognize our amazing contributions to the training and placement of the VLSI industry’s future leaders. We are among the top 10 physical design training institutes because of our truly extensive training program for top students in the electricals and electronics field.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header>5. The Course’s Features</Accordion.Header>
                                            <Accordion.Body>
                                            One of the key reasons for this course’s continuously rising popularity is its key features. The major ones are;<br/><br/>
            <ul>
                <li>
            A hands-on introduction to the flow of physical design training with best tools that fully meet industry standards.</li>
            <li>24/7 laboratory support with the delivery of course materials and lab practice handouts via the best online physical design courses.</li>
            <li>The development of soft skills with a complete suite of physical design courses online which, are job-oriented with 100% placement assistance after the completion of the course.</li>
            <li>Truly deep knowledge of varying technologies and methodologies used in physical design including DFT training.</li>
            <li>Project execution that meets all industry standards from RTL to GDSii training, to theory as well as lab practice sessions that are under the guidance of the industry’s foremost experts who feature more than twelve years of VLSI teaching experience.</li>
            </ul></Accordion.Body>
                                        </Accordion.Item>
                                        </Accordion>
                                        </div>
                                        </div>
                                    </div>
                        </div>
                    </section>
                    
                    <section className='why-sec p-5'>
                    <div class="container text-center">
                                    <div class="row justify-content-around text-center">
                                        <div class="col-md p-5">
                                                <h2 className='ws-section_heading pd-03'>Why Takshila VLSI?</h2>
                                        </div>
                                    </div>

                                    <div class="row">
                                            <div class="col-lg-4 text-left">
                                                <div className='course-icon-bx bg-lt radius-1 mb-4'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>Expert Trainers and Curriculum
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>We collaborate with trainers who have over 15+ years in the industry. All our
            courses are professionally designed and are job-oriented to satisfy the
            demands of the VLSI industry. Our courses are designed by
            Professionals.
            </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 text-left">
                                            <div className='course-icon-bx bg-drk dark-bg radius-1'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>Offline/Online Courses & Affordable Fee
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>Our offline/online VLSI courses are designed to ensure that our students
            gain access to training materials and classrooms at their convenience. We
            offer state-of-the-art courses at very affordable prices.
            </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 text-left">
                                            <div className='course-icon-bx bg-lt radius-1'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>100% Placement Assistance
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>At Takshila VLSI technologies we provide placement support for our students
            till they get placed. We collaborate with over 200+ top-level semiconductor
            companies that provide us with placement opportunities for our students.
            </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-4 text-left">
                                            <div className='course-icon-bx bg-drk-3 dark-bg radius-1'>
                                                    <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                                        <div className='bx-title align-self-center'>Powerful EDA Tools
                                                        </div>
                                                        <div className='bx-icn'><img src={icn1} alt=''/></div>
                                                    </div>
                                                    <div className='icon-bx-bottom'>
                                                        <p>We utilize industrial standard EDA tools for hands-on training of our students.
            During your period as a trainee in our VLSI institute, EDA tools are accessible
            24×7 through our vpn service.
            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 text-left">
                                <div className='course-icon-bx bg-lt radius-1'>
                                        <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                            <div className='bx-title align-self-center'>Superior Training infrastructure and Methodology
                                            </div>
                                            <div className='bx-icn'><img src={icn1} alt=''/></div>
                                        </div>
                                        <div className='icon-bx-bottom'>
                                            <p>We use an unique training methodology for our students with 70% of the course time allocated to the labs, mini-projects, and the final projects. However, the other 30% is allocated to imparting the technologies to our student.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 text-left">
                                <div className='course-icon-bx bg-drk-4 dark-bg radius-1'>
                                        <div className='icon-bx-top d-flex justify-content-between pb-4 '>
                                            <div className='bx-title align-self-center'>Value for Money
                                            </div>
                                            <div className='bx-icn'><img src={icn1} alt=''/></div>
                                        </div>
                                        <div className='icon-bx-bottom'>
                                            <p>We teach you all advanced courses at a reasonable cost. We offer you more for less. With comprehensive lessons, expert guidance, and hands-on experience, you’ll gain the skills you need to succeed without breaking the bank.

                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
        </div>
        </section>
        <Offersec/>

           <section className='corejob-section p-5 bg-14'>
            <div class="container text-center">
                            <div className='row pb-3'>
                                <div className='col-lg text-center'>
                                <h2 class="ws-section_heading">Core Job Opportunities</h2>
                            </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-4 mb-4'>
                                <div class="career-box d-flex p-3 radius-1 dark-bg">
                                            <h6>Physical Design Engineering</h6>
                                            </div>
                                </div>
                                <div className='col-lg-4'>
                                <div class="career-box d-flex p-3 radius-1 dark-bg">
                                            <h6>STA Engineer</h6>
                                            </div>
                                </div>
                                <div className='col-lg-4'>
                                <div class="career-box d-flex p-3 radius-1 dark-bg">
                                            <h6>Physical Verification Engineer</h6>
                                            </div>
                                </div>
                                <div className='col-lg-4'>
                                <div class="career-box d-flex p-3 radius-1 dark-bg">
                                            <h6>EM IR Sign off Engineer</h6>
                                            </div>
                                </div>
                                <div className='col-lg-4'>
                                <div class="career-box d-flex p-3 radius-1 dark-bg">
                                            <h6>Methodology & Flow Engineer</h6>
                                            </div>
                                </div>
                            
                            </div>
                        </div>
    </section>

        <section className='ws-section pb-5 bg-white'>
            <div class="container text-center">
            <div className='row pb-3'>
                    <div className='col-lg text-center'>
                    <h2 class="ws-section_heading">Connect With Us</h2>
                </div>
                </div>
            <div class="row justify-content-around">
                            <div class="col-lg-5">
                                <div className='trainer-box'>
                                    <div className='content-box wd-80 d-flex bg-path'>
                                    <div className='trainer-content'>
                                    <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                    your goals.</h5>
                                    </div>
                                    </div>
                                    <div className='trainer-img img-radius'>
                                    <img src={img4} alt=''/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                
                                <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                
                                />
                            
                            </div>
                        </div>
            </div>
        </section>


        <section className='course-faq-section ws-section p-lg-5 bg-14'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg text-center'>
                    <h2 class="ws-section_heading">Frequently Asked Questions</h2>
                </div>
                </div>
                <div className='row justify-content-center pb-5'>
                    <div className='col-lg-10'>
                    <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>1. What is the focus of the Physical Design Part-Time course?</Accordion.Header>
                                <Accordion.Body>
                                    <p>Our <strong>Physical Design Part-Time</strong> course is all about hands-on experience in VLSI physical design. You will dive into everything from floor planning to routing and physical verification using the latest industry tools. Perfect for professionals who want to level up their skills!</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>2. Who should consider taking this VLSI physical design part-time course?</Accordion.Header>
                                <Accordion.Body>
                                <p>This course is the best option for working professionals who belong to electronics and are looking to deepen their knowledge in VLSI physical design. If you are an engineer or want to master physical design, this is for you!</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>3. What can you expect to learn in the Physical Design Education provided?</Accordion.Header>
                                <Accordion.Body>
                                <p>In our Physical Design Education, you’ll gain a thorough understanding of physical design flow. Expect to learn about Linux environments, power planning, timing analysis, and much more. By the end, you’ll be well-versed in the entire physical design process!</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>4. How does the Physical Design Part-Time course fit into my busy schedule?</Accordion.Header>
                                <Accordion.Body>
                                <p>The course is designed to fit around your existing job. You’ll get flexible access to lab support and materials, making it easier to balance learning with your work commitments.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>5. Who can join the course in the Physical Design Classes?</Accordion.Header>
                                <Accordion.Body>
                                <p>You have to come from an electrical or electronics background, such as a B.E, B.Tech in ECE or EEE, or an M.E, M.Tech, or M.S in VLSI and Embedded Systems. This background ensures that you are able to learn the advanced topics.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>6. Brief description of Physical design course details?</Accordion.Header>
                                <Accordion.Body>
                                <p>We provide the best practical knowledge about the tools and techniques and concentrate on placing you in the best company. It covers everything from basics like Unix/Linux commands and CMOS operations to advanced topics.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>7. How experienced are the instructors for the Physical Design Course?</Accordion.Header>
                                <Accordion.Body>
                                <p>Our instructors, like Mr. Chaitanya, bring over 12 years of hands-on experience in RTL to GDSII implementation. They have worked on complex blocks like PCIe and DDR_PHY so you will be learning from true experts in the field.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header>8. What practical skills will you learn from the Physical Design for Professionals course?</Accordion.Header>
                                <Accordion.Body>
                                <p>You will learn and get real practice with industry-standard EDA tools. You’ll learn how to manage floor planning, power planning, and routing—all crucial skills for a career in physical design.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            </Accordion>
                    </div>
                </div>
                <div class="row justify-content-center mt-5">
                        <div class="col-lg-9">
                            <div class="callaction-2">
                                <div class="row g-3">
                                <div class="col-lg-7">
                                    <h2>Don't see your questions ? answered here?</h2>
                                </div>
                                <div class="col-lg-4 align-self-center text-center">
                                <a href="/contact-us/">
                                <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                </a>
                                </div>
                                </div> 
                            </div>
                        </div>
                    </div>
            </div>
        </section>


        <Videoreview/>
        <Enrollaction/>
        <Partnersec/> 
        </main>
        <Footer/>
        </div>
  )
}

export default Physicalpt